import { FieldError } from 'react-hook-form';
import * as Sentry from '@sentry/react';
import FormField from '../FormField/FormField';
import { errorId } from '../FormField/errorId';
type FormField = {
  id: string;
  label: string;
  required: boolean;
  validation?: {
    name: string;
    pattern: string;
    message: string;
  };
  extId?: boolean;
};

type Props = {
  field: FormField;
  register: any;
  error?: FieldError;
  value?: string;
};

const FormInput = ({ field, register, error, value }: Props) => {
  const { id, label, required, validation } = field;

  const getValidationPattern = () => {
    if (!validation) {
      return /.*/;
    }

    try {
      return new RegExp(validation.pattern);
    } catch (e) {
      Sentry.captureMessage(`Invalid validation pattern: ${validation.pattern}`, "warning");
      console.error('Invalid validation pattern:', validation.pattern);
      return /.*/;
    }
  };

  const inputMode = validation?.name === "phone" ? "tel" : validation?.name === "email" ? "email" : undefined;

  return (
    <FormField
      htmlFor={id}
      label={label}
      required={required}
      error={error ? error.message || 'This field is required' : undefined}
    >
      <input
        id={id}
        className='field-input'
        type={validation?.name === "phone" ? "tel" : "text"}
        inputMode={inputMode}
        aria-invalid={!!error}
        aria-required={required}
        aria-describedby={error ? errorId(id) : undefined}
        {...register(id, {
          required: required,
          pattern: {
            value: getValidationPattern(),
            message: validation?.message
          }
        })}
        data-testid={id}
        defaultValue={value?.toString().replace(/%20/g, ' ')}
      />
    </FormField>
  )
};

export default FormInput;
